import React from 'react';
import PropTypes from 'prop-types';
import * as S from './styled';

/* eslint-disable react/no-array-index-key */
const Patterns = ({ rows, animationDuration = 5, className = '' }) => (
  <S.PatternWrapper className={className}>
    {rows.map((row, rowId) => (
      <S.RowWrapper key={rowId}>
        {row.columns.map((col, colId) => (
          <S.GlowingCircle
            key={colId}
            $diameter={col.width}
            $margin={col.margin}
            $animationDuration={animationDuration}
          />
        ))}
      </S.RowWrapper>
    ))}
  </S.PatternWrapper>
);

Patterns.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      columns: PropTypes.arrayOf(
        PropTypes.shape({
          width: PropTypes.number.isRequired,
          margin: PropTypes.number.isRequired
        })
      ).isRequired
    })
  ).isRequired,
  className: PropTypes.string,
  animationDuration: PropTypes.number
};

export default React.memo(Patterns);
